/**
 * ChartUtilities - Utility Components for Chart Display
 * 
 * SOLID Principle: Single Responsibility Principle (SRP)
 * Purpose: Contains small utility components that support chart functionality
 * without cluttering the main chart component. Each component has a single,
 * well-defined responsibility.
 * 
 * Components:
 * - EmptyState: Display when no data is available
 * - (Future utility components can be added here)
 */

import React from 'react';

/**
 * Empty state component for when no data is available
 */
export function EmptyState({ message }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '400px',
      backgroundColor: '#f8f9fa',
      border: '2px dashed #dee2e6',
      borderRadius: '8px',
      color: '#6c757d',
      fontSize: '1.1rem'
    }}>
      {message}
    </div>
  );
}

export default EmptyState;